import { render } from "./InputModule.vue?vue&type=template&id=db844ae2"
import script from "./InputModule.vue?vue&type=script&lang=js"
export * from "./InputModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__